<form [formGroup]="formGroup">
  <div class="headline">
    @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN' && displayEditingTools) {
      <div class="w49">
        <span class="mat-h1"> Textmuster - </span>
        <mat-form-field appearance="outline" class="marg-right2">
          <mat-label>Name</mat-label>
          <input formControlName="name" matInput placeholder="" required>
        </mat-form-field>
      </div>
    } @else {
      <span class="h1 m0">Textmuster - {{ textPattern?.name }}</span>
    }
    @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN') {
      <span class="editing-group">
        @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
          <button color="primary" mat-flat-button
                  (click)="toggleEditingTools(true); saveChanges()">
            <mat-label>Speichern</mat-label>
          </button>
        }
        @if ((displayEditingTools === false) && (authService.getUserRole() === 'ROLE_ADMIN')) {
          <button (click)="toggleEditingTools(true)"
                  aria-label="Button to enable editing"
                  class="editing-buttons header-buttons" mat-flat-button>
            <mat-icon>edit</mat-icon>
            <mat-label class="home-new-word-bt-text">Bearbeiten</mat-label>
          </button>
        }
      </span>
    }
  </div>
  <hr>
  @if (displayEditingTools) {
    <app-folder-usage-hint [entryId]="textPattern?.id" type="TEXT_PATTERN"></app-folder-usage-hint>
  }
  <div class="main-content-wrapper">
    <!-- Markdown Edit/View -->
    <div class="mat-elevation w60 min-height-50 background-white pad16">
      <div class="">
        <span class="h5">Beschreibung</span>
      </div>
      @if (textPattern) {
        <app-markdown-editor style="flex:1" [readonly]="!displayEditingTools && authService.getUserRole() === 'ROLE_ADMIN'" [content]="textPattern.content"></app-markdown-editor>
      }
    </div>

    <div class="w39 pad16 mat-elevation">
      <div class="pad-bot8">
        <span class="h5">Details</span>
      </div>
      <!-- Edit View -->
      @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN' && displayEditingTools) {
        <div class="flex-col pad-top8">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Fertigkeit</mat-label>
            <mat-select formControlName="mode">
              @for (option of modesList; track option) {
                <mat-option [value]="option">
                  {{ formOptionsLists.modesToString.get(option) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- View Mode -->
      } @else {
        <div class="h6 pad-top8">
          <span>Fertigkeit: {{ formOptionsLists.modesToString.get(textPattern?.mode) }}</span>
        </div>
      }
      <app-reference-table
        [entry]="references"
        [editMode]="true"
        [clickableRefs]="true"
        [selfId]="currentPatternId"
        [selfType]="'text_pattern'"
        (entryChange)="handleReferenceChange($event)">
      </app-reference-table>
    </div>
  </div>
</form>
